import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  ADD_CATALOG_APP_INSTANCE,
  CLEAR_CURRENT_APP_INSTANCE,
  CLEAR_CURRENT_CATALOG_APP,
  DELETE_CATALOG_APP_INSTANCE,
  FETCH_CATALOG_APP,
  FETCH_CATALOG_APP_INSTANCE,
  UPDATE_CATALOG_APP_INSTANCE
} from './actionTypes'
import { AppInstanceConfig } from './interfaces'

export const fetchCatalogApp = (currentSpaceId: string, catalogId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/catalog/${catalogId}`,
        FETCH_CATALOG_APP,
        { headers: { 'x-workgrid-space': currentSpaceId } },
        { service: 'apps' }
      )
    )
  }
}

export const clearCurrentCatalogApp = (): AppThunk => {
  return dispatch => {
    dispatch(createAction(CLEAR_CURRENT_CATALOG_APP))
  }
}

export const addCatalogAppInstance = (appInstanceConfig: AppInstanceConfig, currentSpaceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/catalog/appinstances`,
        ADD_CATALOG_APP_INSTANCE,
        { method: 'POST', headers: { 'x-workgrid-space': currentSpaceId }, body: appInstanceConfig },
        {
          args: {
            appInstanceConfig,
            spaceId: currentSpaceId
          },
          service: 'apps'
        }
      )
    )
  }
}

export const fetchCatalogAppInstance = (appInstanceId: string, currentSpaceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/appinstances/${appInstanceId}`,
        FETCH_CATALOG_APP_INSTANCE,
        { headers: { 'x-workgrid-space': currentSpaceId }, method: 'GET' },
        {
          args: {
            spaceId: currentSpaceId,
            appInstanceId
          },
          service: 'apps'
        }
      )
    )
  }
}

export const updateCatalogAppInstance = (
  appInstanceId: string,
  appInstanceConfig: AppInstanceConfig,
  currentSpaceId: string
): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/catalog/appinstances/${appInstanceId}`,
        UPDATE_CATALOG_APP_INSTANCE,
        { method: 'PUT', headers: { 'x-workgrid-space': currentSpaceId }, body: appInstanceConfig },
        {
          args: {
            spaceId: currentSpaceId
          },
          service: 'apps'
        }
      )
    )
  }
}

export const deleteCatalogAppInstance = (appInstanceId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/catalog/appinstances/${appInstanceId}`,
        DELETE_CATALOG_APP_INSTANCE,
        { method: 'DELETE', headers: { 'x-workgrid-space': ':spaceId' } },
        {
          args: {
            spaceId: ':spaceId',
            appInstanceId
          },
          service: 'apps'
        }
      )
    )
  }
}

export const clearCurrentApp = (): AppThunk => {
  return dispatch => {
    dispatch(createAction(CLEAR_CURRENT_APP_INSTANCE))
  }
}
